// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2kJWT","title":"Header_title__2D_yL","left":"Header_left__F0psu","clinicName":"Header_clinicName__Wji0R"};